// extracted by mini-css-extract-plugin
module.exports = {"container":"Politic_container__9W3Qv","subtitle":"Politic_subtitle__wJlaF","adjust_terms":"Politic_adjust_terms__doz8Z"};